import { supabase } from '../lib/supabaseClient';

export interface AuditLogEvent {
  userId: string;
  organizationId?: string | null;
  realRole?: string | null;
  viewMode?: string | null;
  action: string;
  metadata?: Record<string, unknown> | null;
}

export interface GovernanceReviewEvent {
  id: string;
  action: string;
  created_at: string;
  metadata?: Record<string, unknown> | null;
}

export async function recordAuditEvent(event: AuditLogEvent) {
  if (!event.userId || !event.organizationId) {
    return;
  }

  try {
    await supabase.from('audit_logs').insert({
      user_id: event.userId,
      organization_id: event.organizationId,
      real_role: event.realRole ?? null,
      view_mode: event.viewMode ?? null,
      action: event.action,
      metadata: event.metadata ?? null,
    });
  } catch (error) {
    console.warn('[audit_logs] Falha ao registrar evento', error);
  }
}

export async function listGovernanceReviewEvents(
  organizationId: string,
  projectId: string,
  periodStartIso: string,
): Promise<GovernanceReviewEvent[]> {
  if (!organizationId || !projectId) return [];

  const { data, error } = await supabase
    .from('audit_logs')
    .select('id, action, metadata, created_at')
    .eq('organization_id', organizationId)
    .gte('created_at', periodStartIso)
    .order('created_at', { ascending: false })
    .limit(500);

  if (error) {
    console.warn('[audit_logs] Falha ao consultar revisoes de governanca', error);
    return [];
  }

  const relevant = (data ?? []).filter((row) => {
    const action = String(row.action ?? '').toLowerCase();
    const isGovernanceAction =
      action.includes('review') ||
      action.includes('revis') ||
      action.includes('audit') ||
      action.includes('auditoria') ||
      action.includes('govern');
    if (!isGovernanceAction) return false;

    const metadata = row.metadata as Record<string, unknown> | null;
    const metadataProjectId = metadata
      ? String(metadata.project_id ?? metadata.projectId ?? metadata.linkedProjectId ?? '')
      : '';

    return metadataProjectId === projectId;
  });

  return relevant as GovernanceReviewEvent[];
}
